/**
 * The unit each tag stores its readings in, by tag id, from the org's tags (the cached read every tag picker shares). An
 * alarm rule holds its threshold as a bare number in its tag's unit, so the pages that show or edit one need it
 * (units slice 2b). "" for a tag with no unit and for one not read yet.
 */
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { isLiveApi, listOrgTags } from "@/lib/api";

export function useTagUnitOf(): (tagId: string) => string {
  const orgTags = useQuery({ queryKey: ["org-tags"], queryFn: listOrgTags, enabled: isLiveApi, staleTime: 30_000 });
  return useMemo(() => {
    const unit = new Map((orgTags.data?.items ?? []).map((t) => [t.id, t.unit ?? ""]));
    return (tagId: string) => unit.get(tagId) ?? "";
  }, [orgTags.data]);
}
